<div class="row mt-4">
  <div class="col-12">
    <h1 class="centrar_contenido">Reporte ponderaciones individuales</h1>
  </div>
</div>

<!-- CRITERIOS DE BUSQUEDA -->
<div class="row mt-5 align-items-center">
  <div class="hr-amarillo mr-3"></div>
  <h6 class="mb-0">Criterios de búsqueda</h6>
</div>

<!-- Alertas -->
<div class="alert alert-danger tipografía_alertas mt-4 mb-4 animate__fadeIn" role="alert" *ngIf="alertaErrorDp !== ''">
  <i class="bi bi-x-circle tamanio_iconos-boton mr-2"></i> {{ alertaErrorDp }}
  <button type="button" class="close tipografía_alertas mt-3" data-dismiss="alert" aria-label="Close" data-toggle="collapse" data-target="#collapseWidthExample" aria-expanded="true" aria-controls="collapseWidthExample">
    <span aria-hidden="true" class="alert-danger">&times;</span>
  </button>
</div>
<div class="alert alert-success  tipografía_alertas mt-4 mb-4 animate__fadeIn" role="alert" *ngIf="alertaExitoDp !== ''">
  <i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i>{{ alertaExitoDp }}
  <button type="button" class="close tipografía_alertas mt-3" data-dismiss="alert" aria-label="Close" data-toggle="collapse" data-target="#collapseWidthExample" aria-expanded="true" aria-controls="collapseWidthExample">
    <span aria-hidden="true" class="alert-success">&times;</span>
  </button>
</div>
<!-- Fin alertas -->

<form [formGroup]="parametrosFormDp">
<div class="row mt-5 mb-4 align-items-end">
    <div class="col-3">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Año</label>
        <label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
        <select class="form-control select_criterios" formControlName="anyo"
        [(ngModel)]="filtrosExclusionDp.anyo" (ngModelChange)="resetearValidacion();getListaPeriodos()"
        [ngClass]="{ 'is-invalid': submittedDp && tieneErroresDp['anyo'] }" required>
            <option [value]="0" selected hidden>Seleccionar</option>
            <option [value]="anyo" *ngFor="let anyo of listaAnyosDp">{{anyo}}</option>
        </select>
        <div *ngIf="submittedDp && tieneErroresDp['anyo']" class="invalid-feedback position-absolute">
            <div *ngIf="tieneErroresDp['anyo']">Campo requerido</div>
        </div>
    </div>
    <div class="col-3">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Periodo</label>
        <label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
        <select class="form-control select_criterios" [(ngModel)]="filtrosExclusionDp.periodoId"   formControlName="periodo"
        (ngModelChange)="resetearValidacion();getListaSedes(); getListaAsignatura(filtrosExclusionDp.sedeId,filtrosExclusionDp.tipoAsignaturaId)" [ngClass]="{ 'is-invalid': submittedDp && tieneErroresDp['periodo'] }" required>
            <option [value]="0" selected hidden>Seleccionar</option>
            <option [value]="periodo.periodoAcademicoId" *ngFor="let periodo of listaPeriodosDp">{{periodo.periodoDescripcion}}</option>
        </select>
        <div *ngIf="submittedDp && tieneErroresDp['periodo']" class="invalid-feedback position-absolute">
            <div *ngIf="tieneErroresDp['periodo']">Campo requerido</div>
        </div>
    </div>
    <div class="col-3">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Sede</label>
        <label *ngIf="!rolDaraCentralDp" class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
        <select class="form-control select_criterios" formControlName="sede" [(ngModel)]="filtrosExclusionDp.sedeId" [ngClass]="{ 'is-invalid': submittedDp && tieneErroresDp['sede'] }" (ngModelChange)="resetearValidacion();">
          <option [value] = "0" selected>Seleccionar</option>
          <option [value]="sede.sedeId" *ngFor="let sede of listaSedesDp">{{sede.descripcion}}</option>
        </select>
        <div *ngIf="submittedDp && tieneErroresDp['sede']" class="invalid-feedback position-absolute">
            <div *ngIf="tieneErroresDp['sede']">Campo requerido</div>
        </div>
    </div>
    <div class="col-1 centrar_iconos_botones" [hidden]="currentTabDp !== 'individual'">
        <button type="button" class="boton-buscar" data-toggle="tooltip" data-placement="top" title="BUSCAR" alt="BUSCAR" (click)="buscarReportes()"><i class="bi bi-search"></i></button>
    </div>
    <div class="col-1 centrar_iconos_botones">
        <button type="button" class="boton-secundario tamanio_iconos-boton" data-toggle="tooltip" data-placement="top" title="LIMPIAR" alt="LIMPIAR" (click)="limpiarFiltros()"><i class="bi bi-x"></i></button>
    </div>
</div>
<div class="row mt-3">
    <div class="col-3">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Categoría asignatura</label>
        <select class="form-control select_criterios" formControlName="tipoAsignatura" [(ngModel)]="filtrosExclusionDp.tipoAsignaturaId" (ngModelChange)="resetearValidacion();getListaAsignatura(filtrosExclusionDp.sedeId,filtrosExclusionDp.tipoAsignaturaId)" [ngClass]="{ 'is-invalid': submittedDp && tieneErroresDp['tipoAsignatura'] }" required>
            <option value = "0" selected>Seleccionar</option>
            <option [value]="tipoAsignatura.idCategoria" *ngFor="let tipoAsignatura of listaTipoAsignaturaDp">{{tipoAsignatura.descCategoria}}</option>
        </select>
        <div *ngIf="submittedDp && tieneErroresDp['tipoAsignatura']" class="invalid-feedback">
            <div *ngIf="tieneErroresDp['tipoAsignatura']">Campo requerido</div>
        </div>
    </div>
    <div class="col-3">
            <label class="titulo_criterios" for="exampleFormControlSelect2">Sigla asignatura</label>
            <div class="input-group mb-0">
                <mat-autocomplete #autoAsignatura="matAutocomplete" [displayWith]="displayFnAsignatura">
                    <mat-option *ngFor="let asignatura of filteredAsignaturaDp | async" [value]="asignatura">
                        {{asignatura?.codigo}}
                    </mat-option>
                </mat-autocomplete>
                <input type="text" class="form-control select_criterios" placeholder="Sigla asignatura"
                    aria-describedby="basic-addon2" [formControl]="searchAsignaturaFormDp" formControlName="asignatura" [matAutocomplete]="autoAsignatura" [ngClass]="{ 'is-invalid': submittedDp && tieneErroresDp['asignatura'] }" required (ngModelChange)="resetearValidacion()">
                    <div *ngIf="submittedDp && tieneErroresDp['asignatura']" class="invalid-feedback">
                      <div *ngIf="tieneErroresDp['asignatura']">Debes seleccionar una asignatura</div>
                    </div>
            </div>
    </div>
    <div class="col-3">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Sección</label>
        <div class="input-group mb-0">
            <mat-autocomplete #autoSeccion="matAutocomplete" [displayWith]="displayFnSeccion">
                <mat-option *ngFor="let seccion of filteredSeccionDp | async" [value]="seccion">
                  {{seccion?.codigo}}
                </mat-option>
            </mat-autocomplete>
            <input type="text" class="form-control select_criterios" placeholder="Sección" aria-describedby="basic-addon2" [formControl]="searchSeccionFormDp" formControlName="seccion" [matAutocomplete]="autoSeccion">
        </div>
    </div>
    
</div>
</form>
<div class="alert alert-danger tipografía_alertas mt-4 mb-4 animate__fadeIn" role="alert" *ngIf="errorDp">
    <i class="bi bi-x-circle tamanio_iconos-boton mr-2"></i> {{ errorDp }}
    <button type="button" class="close tipografía_alertas mt-3" data-dismiss="alert" aria-label="Close" data-toggle="collapse" data-target="#collapseWidthExample" aria-expanded="true" aria-controls="collapseWidthExample">
      <span aria-hidden="true" class="alert-danger">&times;</span>
    </button>
</div>
<div class="alert alert-success  tipografía_alertas mt-4 mb-4 animate__fadeIn" role="alert" *ngIf="mensajeExitoDp">
    <i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i>{{mensajeExitoDp}}
    <button type="button" class="close tipografía_alertas mt-3" data-dismiss="alert" aria-label="Close" data-toggle="collapse" data-target="#collapseWidthExample" aria-expanded="true" aria-controls="collapseWidthExample">
      <span aria-hidden="true" class="alert-success">&times;</span>
    </button>
</div>
<!-- FIN CRITERIO DE BUSQUEDA -->

<div class="row justify-content-end pb-4">
  <button (click)="generarReporte()" class="btn boton-primario mt-4 mr-4"
    data-toggle="tooltip" data-placement="top" title="GENERAR REPORTE" alt="GENERAR REPORTE"
    style="position: absolute; z-index: 1;">
    GENERAR REPORTE
  </button>
</div>

<div class="contenedor-exclusion-individual pt-5 pb-5">
  <!-- TABLA -->
  <div style="margin-top: 20px;">
      <table *ngIf="!tableRender" [dtOptions]="dtOptionsDp" datatable class="table table-striped tabla display nowrap" aria-describedby="tabla configuracion exclusiva">
          <thead class="header_tabla">
              <tr>
                  <th>Id Proceso</th>
                  <th>Fecha</th>
                  <th>Usuario</th>
                  <th>Estado del proceso</th>
                  <th>Observaciones</th>
                  <th>Descargar archivo</th>
              </tr>
          </thead>
          <tbody>
          </tbody>
      </table>
      <table [dtOptions]="dtOptionsDp" datatable class="table table-striped tabla display nowrap" *ngIf="tableRender" aria-describedby="tabla configuracion exclusiva">
          <thead class="header_tabla">
              <tr>
                <th>Id Proceso</th>
                <th>Fecha</th>
                <th>Usuario</th>
                <th>Estado del proceso</th>
                <th class="th-mensaje-observaciones">Observaciones</th>
                <th>Descargar archivo</th>
              </tr>
          </thead>
          <tbody>
              <tr *ngFor="let reporte of listaReportesDp">
                  <td>{{reporte.idProceso}}</td>
                  <td>{{reporte.fechaProceso}}</td>
                  <td>{{reporte.usuarioCreacion}}</td>
                  <td>
                    <span class="badge badge-pill finalizado d-flex justify-content-center py-2" *ngIf="reporte.estadoProceso == 'F'">Finalizado</span>
                    <span class="badge badge-pill en_proceso d-flex justify-content-center py-2" *ngIf="reporte.estadoProceso == 'EP'">En proceso</span>
                    <span class="badge badge-pill error d-flex justify-content-center py-2" *ngIf="reporte.estadoProceso == 'ER'">Error</span>
                  </td>
                  <td class="td-mensaje-observaciones">
                    <p class="celda text-wrap">{{reporte.mensajeProceso}}</p>
                  </td>
                  <td class="text-center py-0">
                    <button (click)="obtenerReporte(reporte.idProceso)" class="btn p-0" data-toggle="tooltip" data-placement="top" title="DESCARGAR REPORTE" alt="DESCARGAR REPORTE" *ngIf="reporte.estadoProceso == 'F'"><i class="bi bi-filetype-xlsx icono-tabla"></i></button>
                  </td>
              </tr>
          </tbody>
      </table>
  </div>
  <!-- FIN TABLA -->
</div>